// extracted by mini-css-extract-plugin
module.exports = {"label":"Filter_label__3nhrb","input":"Filter_input__1w1B_"};